import { useState, useRef, FC, useEffect } from "react";
import styled from "styled-components";
import { CorporateTheme } from "../../utils/themes";
import ActionIcon from "../../assets/icons/ActionsIcon";
import ExportIcon from "../../assets/icons/ExportIcon";
import ImportIcon from "../../assets/icons/ImportIcon";
import ColumnIdentifierIcon from "../../assets/icons/ColumnIdentifierIcon";
import DeleteIcon from "../../assets/icons/DeleteIcon";
import { useTheme } from "../../middleware/ThemeContext";
import MergeIcon from "../../assets/icons/MergeIcon";
import LoadingCircleIcon from "../../assets/icons/LoadingCircleIcon";

// interface ActionsProps {
//   showCheckboxColumn: boolean;
//   onToggleSelectRecords: () => void;
//   onToggleColumnIdentifier: () => void;
//   onSelectAll?: (ids: number[]) => void;
//   onDeselectAll: () => void;
//   onDeleteSelected?: () => void;
//   onExport?: () => void;
//   handelMerge?: () => void;
//   selectedCount: number;
//   totalCount: number;
//   title?: string;
// }

type ActionType =
  | "deleteSelected"
  | "toggleColumnIdentifier"
  | "export"
  | "toggleSelect"
  | "mergeContacts"
  | "mergeOrganizations";

type ActionItemConfig = {
  type: ActionType;
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  visible: boolean;
  isLoading?: boolean;
};

interface ActionsProps {
  actions: ActionItemConfig[];
  disabled?: boolean;
}

const ActionsContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ActionsButton = styled('button')<{ $isOpen?: boolean, disabled?: boolean }>(
  ({ theme, $isOpen, disabled }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: CorporateTheme.spacing.sm,
    border: 'none',
    background: $isOpen
      ? theme.CorporateTheme.colors.filterBG
      : 'none',
    padding: `${CorporateTheme.spacing.sm} ${CorporateTheme.spacing.sm}`,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? '0.5' : '1',
    color: theme.CorporateTheme.colors.textSecondary,
    fontSize: '14px',
    fontFamily: '"Raleway", sans-serif',
    fontWeight: 500,
    transition: 'all 0.2s',
    borderRadius: CorporateTheme.borderRadius,

    '&:hover': {
      color: theme.CorporateTheme.colors.accent,
      background: $isOpen
        ? theme.CorporateTheme.colors.filterBG
        : disabled
        ? 'transparent'
        : 'rgba(0, 0, 0, 0.05)',
    },
  })
);

const ActionsPanel = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  right: 0,
  background: theme.CorporateTheme.colors.background,
  border: `1px solid ${theme.CorporateTheme.colors.border}`,
  borderRadius: CorporateTheme.borderRadius,
  padding: CorporateTheme.spacing.sm,
  marginTop: CorporateTheme.spacing.xs,
  minWidth: 'max-content',
  boxShadow: `0 4px 12px ${theme.CorporateTheme.shadow}`,
  zIndex: 100,
}));

const ActionItem = styled('button')(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 500,
  fontFamily: '"Raleway", sans-serif',
  display: 'flex',
  alignItems: 'center',
  gap: CorporateTheme.spacing.sm,
  width: '100%',
  padding: CorporateTheme.spacing.sm,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  textAlign: 'left',
  color: theme.CorporateTheme.colors.textSecondary,
  transition: 'all 0.2s',

  '&:hover': {
    color: theme.CorporateTheme.colors.accent,
    background: theme.CorporateTheme.colors.filterBG,
  },

  '&:disabled': {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
}));

// const Actions: FC<ActionsProps> = ({
//   showCheckboxColumn,
//   onToggleSelectRecords,
//   onToggleColumnIdentifier,
//   onSelectAll,
//   onDeselectAll,
//   onExport,
//   onDeleteSelected,
//   selectedCount,
//   title,
//   totalCount,
//   handelMerge,
// }) => {
//   const { theme } = useTheme();
//   const [isOpen, setIsOpen] = useState(false);
//   const containerRef = useRef<HTMLDivElement>(null);
//   const shouldShowDynamicColumns =
//     !!title && !title.includes("Form") && !title.includes("Field") && !title.includes("Components");
//   const shouldShowBulkDelete =
//     !!title && title.includes("Form");
//   const shouldShowMerge = !!title && title.includes("Contacts Listing");
//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (
//         containerRef.current &&
//         !containerRef.current.contains(event.target as Node)
//       ) {
//         setIsOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <ActionsContainer ref={containerRef}>
//       <ActionsButton theme={theme} $isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
//         <ActionIcon color={theme.CorporateTheme.colors.textSecondary} />
//         Actions
//       </ActionsButton>
//       {isOpen && (
//         <ActionsPanel theme={theme}>
//           {showCheckboxColumn && shouldShowBulkDelete && (
//             <ActionItem theme={theme} onClick={onDeleteSelected}>
//               <DeleteIcon />
//               Delete Selected
//             </ActionItem>
//           )}
//           {shouldShowDynamicColumns && (
//             <ActionItem theme={theme} onClick={onToggleColumnIdentifier}>
//               <ColumnIdentifierIcon color={theme.CorporateTheme.colors.textSecondary} />
//               Column Identifier
//             </ActionItem>
//           )}
//           {/* <ActionItem theme={theme}>
//             <ImportIcon color={theme.CorporateTheme.colors.textSecondary} />
//             Import Data
//           </ActionItem> */}
//           <ActionItem
//             theme={theme}
//             onClick={onExport}
//           >
//             <ExportIcon color={theme.CorporateTheme.colors.textSecondary} />
//             Export Data
//           </ActionItem>
//           <ActionItem theme={theme} onClick={onToggleSelectRecords}>
//             <ColumnIdentifierIcon color={theme.CorporateTheme.colors.textSecondary} />
//             {showCheckboxColumn ? "Hide Selection" : "Show Selection"}
//           </ActionItem>
//           {shouldShowMerge &&
//             <ActionItem theme={theme} onClick={handelMerge}>
//               <MergeIcon color={theme.CorporateTheme.colors.textSecondary} />
//               Merge Contacts
//             </ActionItem>
//           }
//         </ActionsPanel>
//       )}
//     </ActionsContainer>
//   );
// };

const Actions: FC<ActionsProps> = ({ actions, disabled }) => {
  const { theme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleActions = () => {
    if (disabled) return
    setIsOpen(!isOpen)
  }

  return (
    <ActionsContainer ref={containerRef}>
      <ActionsButton theme={theme} $isOpen={isOpen} onClick={handleActions} disabled={disabled}>
        <ActionIcon color={theme.CorporateTheme.colors.textSecondary} />
        Actions
      </ActionsButton>
      {isOpen && (
        <ActionsPanel theme={theme}>
          {actions
            .filter((action) => action.visible)
            .map((action) => (
              <ActionItem key={action.type} theme={theme} onClick={action.onClick}>
                {action.icon}
                {action.label}
                {action.isLoading && <LoadingCircleIcon color={theme.CorporateTheme.colors.textSecondary} />}
              </ActionItem>
            ))}
        </ActionsPanel>
      )}
    </ActionsContainer>
  );
};


export default Actions;
